import React, { useState, lazy, Suspense, memo } from "react";
import { ConfigProvider } from "antd";
import Routes from "../../routes";

const AppLayout = lazy(() => import("./AppLayout"));
const AuthLayout = lazy(() => import("./AuthLayout"));

function Layout() {
  const token = sessionStorage.getItem("Token");
  const Layout = token ? AppLayout : AuthLayout;
  return (
    <ConfigProvider>
      <Suspense>
        <Layout>
          <Routes />
        </Layout>
      </Suspense>
    </ConfigProvider>
  );
}

export default Layout;  
